import React from "react";
import colors from "../../utils/colors";
import styled from "styled-components";
import { cardData } from "../data/data";

const Layout = styled.div`
  padding: 0 0 80px 0;
  background: #f6f6f6;
  .card-container {
    display: grid;
    grid-template-columns: 1fr;
    justify-content: center;
    padding: 30px 15%;
    grid-row-gap: 40px;
    @media (max-width: 768px) {
      grid-row-gap: 30px;
      padding: 20px 5%;
    }
  }
  .card-container img {
    width: 100%;
    height: 366px;
    object-fit: cover;
  }
  .card-content {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    @media (max-width: 768px) {
      grid-template-columns: 1fr;
    }
  }
  .desc {
    background: #fff;
  }
  .textContainer {
    padding: 60px 45px 50px 45px;
    @media (max-width: 768px) {
      padding: 40px 30px 40px 30px;
    }
  }
`;

function GuestRoom() {
  return (
    <>
      <Layout>
        <div className="card-container">
          {cardData &&
            cardData.map((card) => {
              return (
                <div key={card.id} className="card-content">
                  <div className="desc">
                    <div className="textContainer">
                      <p style={styles.title}>{card.title}</p>
                      <p style={styles.subTitle}>{card.subtitle}</p>
                      <p style={styles.text}>{card.desc}</p>
                    </div>
                  </div>
                  <div>
                    <img src={card.imgUrl} alt="pix" />
                  </div>
                </div>
              );
            })}
        </div>
      </Layout>
    </>
  );
}
const styles = {
  text: {
    fontSize: 14,
    display: "flex",
    justifyContent: "center",
    fontWeight: 500,
    // transform: "rotate(-10deg)",
    marginBottom: 24,
    // width: "50%",
    color: colors.dark,
    fontFamily: "sans-serif ",
    textAlign: "center",
  },
  title: {
    fontSize: 20,
    fontWeight: 700,
    // transform: "rotate(-10deg)",
    marginBottom: 10,
    marginTop: "13px",
    color: colors.dark,
    fontFamily: "sans-serif ",
  },
  subTitle: {
    fontSize: 19,
    fontWeight: 500,
    // transform: "rotate(-10deg)",
    marginBottom: 10,
    marginTop: "13px",
    color: colors.dark,
    fontFamily: "sans-serif ",
  },
};
export default GuestRoom;
